import {AppService} from '@shared/services/app.service';
import {UserRepository} from '@app/@core/repositories/user.repository';
import {matchSorter} from 'match-sorter';
import {BaseSearch} from '@shared/helper/search/base-search';

export class UserSearch extends BaseSearch {
    constructor(
        private appService: AppService,
        private userRepository: UserRepository,
        private callback: (value: string) => void
    ) {
        super();
    }

    onSearch(): void {
        this.userRepository.search(this.term.trim()).subscribe((users) => {
            this.filteredModel = matchSorter(users, this.term, {
                keys: ['fname', 'lname', 'email', 'mobile']
            }).map((user) => ({
                value: user.id,
                label: `${user.fname} ${user.lname} ${user.email} ${user.mobile}`
            }));

            if (this.filteredModel.length === 0) {
                this.appService.toastAlert('Not found');
            }
        });
    }

    onSelected(value): void {
        this.callback(value);
    }
}
